import {useQuery} from "@tanstack/react-query";
import {ApiConfig} from "@/config/api.config";
import {DashboardTotalOwnersResponseDto} from '@/features/dashboard/types/dashboard-dto';
import {ApiHookProps} from '@/@types/api.types';
import {useDashboardFilter} from '@/features/dashboard/hooks/useDashboardFilter';
import {UrlHelper} from '@/utils/UrlHelper';
import {DateTimeHelper} from '@/utils/dateTimeHelper';
import {useAxiosAuth} from "@/hooks/useAxiosAuth.ts";

export const useDashboardTotalOwnersApi = () => {
    const axiosInstance = useAxiosAuth();
    const {filter} = useDashboardFilter();
    const {startDate, endDate, apartmentId} = filter;

    const apartmentIds = apartmentId?.map((apartment) => apartment.id);

    const {
        data: totalOwnersData,
        isLoading: isLoadingTotalOwnersData,
        isError: isErrorTotalOwnersData
    } = useQuery({
        queryKey: [
            ApiConfig.queries.features.dashboard.queryKeys.totalOwners,
            startDate, endDate, apartmentId
        ],
        queryFn: async () => {
            const url = UrlHelper.buildUrlWithQueryParams(ApiConfig.queries.features.dashboard.endpoints.totalOwners, {
                startDate: DateTimeHelper.getDateOnly(startDate),
                endDate: DateTimeHelper.getDateOnly(endDate),
                apartmentId: apartmentIds
            });
            const {data} = await axiosInstance.get<DashboardTotalOwnersResponseDto>(url);
            return data;
        },
    });

    return {
        totalOwnersData,
        isLoadingTotalOwnersData,
        isErrorTotalOwnersData,
    }
};